import { PlusIcon } from "@phosphor-icons/react";

const IndividualAddCard = (props) => {
    return (
        <div className="Add" onClick={props.onClick}>
            <div className="card flex col r4-3 center-center">
                <div className="icon large">
                    <PlusIcon size={24} />
                </div>
            </div>
        </div>
    );
};

export default IndividualAddCard;
